<template>
  <div class="brl-top scroll-hidden">
    <global-loading v-if="$store.state.vaStore.total_vendor_kplh_loading" />
    <div v-if="hoverActive" class="k3l-kplh-tooltip">
      <div class="box-k3l-kplh-bg mr10" :style="`background-color: ${itemActive ? itemActive.color : 'transparant'};`
        ">
        &nbsp;
      </div>
      <div>
        <div>{{ itemActive ? itemActive.tingkat_resiko : '' }}</div>
        <div>{{ itemActive ? itemActive.total_keterangan : '' }}</div>
      </div>
    </div>
    <div class="pointer" style="position:absolute;right:2%;top:2%;font-size:20px">
      <i class="fa-solid fa-file-arrow-down" style="color:red" @click="downloadReport()"></i>
    </div>
    <div class="text-sm text-bold mb10">Praqualifikasi KPLH Vendor</div>
    <div class="treemap-container cursor-pointer" v-if="totalVendor">
      <div class="treemap-wrapper" :style="`
          width: calc(100% - ${100 -
        (maxValueChart() / totalMaxValue()) * 100}%);
          height: 100%
        `
        ">
        <div v-for="(item, index) in treemap" :key="index" :style="`
            width: 100%;
            height: calc(100% - ${totalTreemap(item.total_keterangan)}%);
            background-color:${item.color};
            display: flex;
          `
          ">
          <div :class="`text-white text-sm w-full`" @mouseenter="hoverOn(item)" @mouseleave="hoverOff">
            <div>{{ item.tingkat_resiko }}</div>
            <div>{{ item.total_keterangan }}</div>
          </div>
        </div>
      </div>
      <div class="treemap-wrapper" :style="`width:calc(100% - ${100 -
        (maxValueChart2() / totalMaxValue()) * 100}%);`
        ">
        <div v-for="(item, index) in treemap2" :key="index + 10" :style="`
            width: calc(100% - ${item.total_keterangan / getMax()}%);
            height: calc(100% - ${totalTreemap2(item.total_keterangan)}%);
            background-color:${item.color};
            display: flex;
          `
          ">
          <div :class="`text-white text-sm w-full`" @mouseenter="hoverOn(item)" @mouseleave="hoverOff">
            <div>{{ item.tingkat_resiko }}</div>
            <div>{{ item.total_keterangan }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
import moment from 'moment'
export default {
  components: {
    barChart: () => import('@/components/chart/dashboard/bar-chart.vue'),
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      treemap: [],
      treemap2: [],
      hoverActive: false,
      itemActive: null,
    }
  },
  created() {
    // this.$store.dispatch('vaStore/getTotalVendorKPLH')
  },
  computed: {
    totalVendor() {
      const data = this.$store.state.vaStore.total_vendor_kplh
      this.convertData(data)

      return true
    },
  },
  methods: {
    hoverOn(item) {
      this.hoverActive = true
      this.itemActive = item
    },
    hoverOff(item) {
      this.hoverActive = false
      this.itemActive = null
    },
    convertData(data) {
      let treemap = []
      let treemap2 = []
      for (let i in data) {
        switch (data[i]?.tingkat_resiko?.toUpperCase()) {
          case 'RENDAH':
            data[i].color = '#ff9900'
            break
          case 'SEDANG':
            data[i].color = '#ff6600'
            break
          case 'TINGGI':
            data[i].color = '#ff3333'
            break
          case 'KRITIS':
            data[i].color = '#990000'
            break

          default:
            break
        }

        if (i < 2) {
          treemap.push(data[i])
        } else {
          treemap2.push(data[i])
        }
      }
      this.treemap = treemap
      this.treemap2 = treemap2
    },
    totalTreemap(value) {
      if (this.treemap && this.treemap.length > 0) {
        const result = this.treemap.reduce(function (acc, obj) {
          return acc + obj.total_keterangan
        }, 0)
        // const maxValue = Math.max(...this.treemap.map(o => o.vendor))
        return 100 - (value / result) * 100
      }
      return 0
    },
    totalTreemap2(value) {
      if (this.treemap2 && this.treemap2.length > 0) {
        const result = this.treemap2.reduce(function (acc, obj) {
          return acc + obj.total_keterangan
        }, 0)
        // const maxValue = Math.max(...this.treemap.map(o => o.vendor))
        return 100 - (value / result) * 100
      }
      return 0
    },
    maxValueChart() {
      if (this.treemap && this.treemap.length > 0) {
        const maxValue = Math.max(...this.treemap.map(o => o.total_keterangan))
        return maxValue
      }
      return 0
    },
    maxValueChart2() {
      if (this.treemap2 && this.treemap2.length > 0) {
        const maxValue = Math.max(...this.treemap2.map(o => o.total_keterangan))
        return maxValue
      }
      return 0
    },
    totalMaxValue() {
      return this.maxValueChart() + this.maxValueChart2()
    },
    getMax() {
      let maxValue = 0
      let maxValue2 = 0

      if (this.treemap && this.treemap.length > 0) {
        maxValue = Math.max(...this.treemap.map(o => o.total_keterangan))
      }

      if (this.treemap2 && this.treemap2.length > 0) {
        maxValue2 = Math.max(...this.treemap2.map(o => o.total_keterangan))
      }

      if (maxValue > maxValue2) {
        return maxValue
      }
      return maxValue2
    },
    async downloadReport() {
      let dateReport = moment().format('DDMMYY')
      let daterange = ''
      let start = this.$store.state.vaStore.start
      let end = this.$store.state.vaStore.end

      if (start && end) {
        daterange += `${start} - ${end}`
      }

      const total = await this.$store.dispatch(
        'vaStore/getTotalVendorKPLHExport'
      )
      total.unshift({})

      const newMapping = total.map(i => {
        return {
          isupplier_code: i.isupplier_code,
          vendor_id: i.vendor_id,
          nama_vendor: i.nama_vendor,
          pic: i.pic,
          last_reviewer: i.last_reviewer,
          keterangan:
            new Date().getTime() < new Date(i.tanggal_berakhir).getTime()
              ? i.keterangan
              : 'EXPIRED',
          tingkat_resiko: i.tingkat_resiko,
          tanggal_efektif: i.tanggal_efektif,
          tanggal_berakhir: i.tanggal_berakhir,
          nilai: i.nilai,
        }
      })

      let wb = XLSX.utils.book_new()
      let data = XLSX.utils.json_to_sheet(newMapping)
      const title = [
        [
          `Praqualifikasi_KPLH_${dateReport}`,
          daterange,
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'Isupplier Code',
          'ID Vendor',
          'Nama Vendor',
          'PIC',
          'Last Reviewer',
          'Keterangan',
          'Tingkat Risiko',
          'Tanggal Efektif',
          'Tanggal Berakhir',
          'Nilai',
        ],
      ]
      XLSX.utils.book_append_sheet(wb, data, 'Report')
      XLSX.utils.sheet_add_aoa(data, title, {
        origin: 'A1',
      })
      XLSX.writeFile(wb, 'REPORT_PRAQUALIFIKASI_KPLH.xlsx')
    },
  },
}
</script>
<style scoped>
.treemap-container {
  width: 100%;
  height: 87%;
  background-color: gray;
  display: flex;
}
</style>
